import React from "react";
import { ListItem } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import clsx from "clsx";

const useStyles = makeStyles(theme => ({
  alertBackground: {
    backgroundColor: theme.palette.action.alert
  },
  listItem: {
    padding: theme.spacing(2, 0, 2, 0)
  }
}));

export default function TodoItem(props) {
  const classes = useStyles();
  return (
    <ListItem
      alignItems="flex-start"
      className={clsx(classes.listItem, {
        [classes.alertBackground]: props.overdue && props.highlightBackground
      })}
    >
      {props.item}
    </ListItem>
  );
}
